type HeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: HeadingProps) {
  const centered = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${centered ? "items-center text-center" : "items-start"}`}>
      <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
        <span className="h-2 w-2 rounded-full bg-accent-500" />
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">{title}</h2>
      {desc && <p className={`max-w-2xl text-sm leading-relaxed text-foreground-600 ${centered ? "mx-auto" : ""}`}>{desc}</p>}
    </div>
  );
}